import { render, staticRenderFns } from "./Goals.vue?vue&type=template&id=4c8f7ff2&scoped=true&"
var script = {}
import style0 from "./Goals.vue?vue&type=style&index=0&id=4c8f7ff2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8f7ff2",
  null
  
)

export default component.exports